// @ts-strict-ignore
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ArrayUtils } from '@shared/util/array-utils';
import { ProjectHeadVO } from '@project/model/vo/project.vo';
import { ProjectGroupVO } from '@project/model/vo/project-group.vo';
import { ProjectGroupUtils } from '@project/components/project/util/project-group-utils';

export interface CopyProjectOperationProperties {
  copyProjectProperties: boolean;
  copyConfigurationProperties: boolean;
}

@Component({
  standalone: false,
  selector: 'copy-project-or-configuration-modal',
  templateUrl: './copy.component.html'
})
export class CopyProjectPopupComponent {
  @Input() itemToCopy: ProjectGroupVO | ProjectHeadVO;
  @Output() public finish = new EventEmitter<CopyProjectOperationProperties | null>();

  public copyProjectProperties: boolean = false;
  public copyConfigurationProperties: boolean = false;

  public isCopyProjectPropertiesAvailable(): boolean {
    return this.itemToCopy instanceof ProjectGroupVO;
  }

  public isCopyConfigurationPropertiesAvailable(): boolean {
    return !(this.itemToCopy instanceof ProjectGroupVO &&
      ProjectGroupUtils.isConfigurationGroup(this.itemToCopy) &&
      this.itemToCopy.childContentLoaded &&
      ArrayUtils.isEmpty(this.itemToCopy.projects));
  }

  public cancel(): void {
    this.finish.emit(null);
  }

  public apply(): void {
    this.finish.emit({
      copyProjectProperties: this.copyProjectProperties,
      copyConfigurationProperties: this.copyConfigurationProperties
    });
  }
}
